// const BASE_URL = 'http://localhost:6014'
const BASE_URL = process.env.REACT_APP_BASE_URL


const routes = {
    LOGIN: "/admin/login",
    GET_ADMIN_PROFILE: "/admin/get_admin",
    DASHBOARD: "/admin/dashboard",

    ALL_USERS: "/admin/get_all_users",
    USER: "/admin/get_single_user",
    UPDATE_PROFILE: "/admin/update-profile",
    BLOCK_USER: "/admin/blockUser/",
    DELETE_USER: "/admin/delete_user",


    GET_PROMPTS: '/admin/get_prompt',
    CREATE_PROMPT: '/admin/create_prompt',
    UPDATE_PROMPT: '/admin/update_prompt',
    DELETE_PROMPT: '/admin/delete_prompt',
    GET_PASSION_IDEAS: '/admin/passion_ideas',
    CREATE_PASSION_IDEA: '/admin/create_passion_idea',
    UPDATE_PASSION_IDEA: '/admin/update_passion_idea',
    GET_QUESTION_PROMPTS: '/admin/get_question_prompt',

    GET_QUOTES_AFFIRMATION: '/admin/get_quotes_affirmation',
    POST_QUOTES_AFFIRMATION: '/admin/post_quotes_affirmation',
    PATCH_QUOTES_AFFIRMATION: '/admin/patch_quotes_affirmation',
    DELETE_QUOTES_AFFIRMATION: '/admin/delete_quotes_affirmation',
    GET_PRIVACY_POLICY: "/admin/get_content",
    UPDATE_CONTENT: "/admin/update-content",

    GET_INTENTION: "/admin/get_intention",
    CREATE_INTENTION: "/admin/create_intention",
    DELETE_INTENTION: "/admin/delete_intention",
    UPDATE_INTENTION: "/admin/update_intention",
    GET_REPORTED_REFLECTIONS: "/admin/reported-reflections",
    GET_BUILD_VERSION: '/admin/get_build_version',
    CREATE_BUILD_VERSION: '/admin/create_build_version',
    SEND_NOTIFICATION_TO_ALL: '/admin/notify-all',
}

export default routes;
export { BASE_URL }